import { FLOW_TYPES, FLOW_TYPES_URLS, FLOW_TYPE_TCOL, INIT_TYPES } from './flowTypes';
import { DOC_TYPE_CODE, USER_TYPE } from '../bitConstants/constants';
import {
  emptyStep,
  obdResidenceErrorStep,
  obdErrorStep,
  personalDataStepInitial,
  personalDataStep,
  personalDataStepWithoutInitCQ,
  shipmentStep,
  paymentStep,
  commitmentStep,
  scoringStep,
  summaryStep,
  confirmationStep,
  permanentResidenceStep,
  installationStep,
  selectParentProductStep,
  mainActionStep,
  mobileSecondaryActionStep,
  riskStep,
  ppipStep,
  VTLSummaryStep,
  VTLCardPaymentStep,
  DeviceConfirmationStep,
  deviceInstallationStep,
  deviceSummaryStep,
  chooseNumberOTPStep,
  signatureStep,
  landLineSecondaryActionStep,
  alreadyOwnedProductsChoicesStep,
  packSummaryStep,
  forcedInstallationStep,
  afterSaleParentProductSelectorStep,
  productOfferingToBuyChanged,
  manualSummaryStep,
  VTLNewClientSummary,
  manualNewClientSummaryStep,
  debtErrorStep,
  riskErrorStep,
  creditLimitErrorStep,
  oneClickSummaryStep,
  DuoNewClientSummary,
  portabilityOTPStep,
  numberOfSimsStep,
  manualRenewalSummaryStep,
  genericSignatureStep,
} from './commonSteps';

import { PURCHASE_TYPE } from '../tagging';
import { PRODUCT_TYPES } from '../utils/catalog';
import { CHARACTERISTIC_VALUES, CQ_ACTION_CODES, CQ_POTS } from '../catalogConstants';
import { WEBSERVICE_ERRORS } from '../errorManagement/errorCatalog';
import { stepIds } from './stepIds';
import { WAITING_PAGE_ANIMATIONS } from '../bitComponents/WaitingPage';

const getFlowIdNResetPath = (pathname) => {
  let flowId = null;
  let resetPath = null;

  Object.keys(FLOW_TYPES_URLS).forEach((key) => {
    const urls = FLOW_TYPES_URLS[key];

    const newResetPath = urls.find(url => pathname.indexOf(url) !== -1);

    if (newResetPath) {
      resetPath = newResetPath;
      flowId = FLOW_TYPES[key];
    }
  });

  return {
    flowId,
    resetPath,
  };
};

export const createFlow = (pathname, userType, isRegisteredShopper) => {
  const { flowId, resetPath } = getFlowIdNResetPath(pathname);

  let flow = null;
  switch (flowId) {
    case FLOW_TYPES.MOBILE_LINES: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: personalDataStep,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          productOfferingToBuyChanged,
          permanentResidenceStep,
          mainActionStep,
          mobileSecondaryActionStep,
          shipmentStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.MOBILE_LINES,
        retargeting: true,
        initialStepForMinder: 'initial',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
        buyProductOfferingAltWhenErrors: [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L, WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]
      };
      break;
    }
    case FLOW_TYPES.ACTIVATE_MOBILE_LINE: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          permanentResidenceStep,
          mainActionStep,
          mobileSecondaryActionStep,
          shipmentStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.ACTIVATE_MOBILE_LINE,
        hideSummaryLegals: true,
        initialStepForMinder: 'initial',
        isExtendedActivationFlow: true,
        blockNoAction: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.XBOX_GAME_PASS: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: personalDataStep,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          permanentResidenceStep,
          paymentStep,
          riskStep,
          summaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.XBOX_GAME_PASS,
        initialStepForMinder: 'initial',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.INTERNET: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: personalDataStepWithoutInitCQ,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepWithoutInitCQ,
          forcedInstallationStep,
          landLineSecondaryActionStep,
          ppipStep,
          deviceInstallationStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        avoidAddressesOfProductType: PRODUCT_TYPES.PACK,
        flowName: FLOW_TYPES.INTERNET,
        initialStepForMinder: 'initialBaf',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepWithoutInitCQ,
          selectParentProductStep,
          paymentStep,
          riskStep,
          summaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS,
        initialStepForMinder: 'initialProductsToHire',
        isSimpleActivationFlow: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.BONUS: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepWithoutInitCQ,
          selectParentProductStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.BONUS,
        initialStepForMinder: 'initialProductsToHire',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.MOVISTAR_PLUS: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          permanentResidenceStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.MOVISTAR_PLUS,
        initialStepForMinder: 'initial',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
        sendFailToGenesys: true,
      };
      break;
    }
    case FLOW_TYPES.DEVICES: {
      let initialStepForMinder = 'initialNonOffer';
      let useCatalogPrice = false;
      let steps = [
        emptyStep,
        obdResidenceErrorStep,
        obdErrorStep,
        personalDataStep,
        VTLSummaryStep,
        VTLCardPaymentStep,
        riskStep,
        DeviceConfirmationStep,
      ];
      let confirmationInfo = {
        paths: ['/order/telco/dispositivos/confirmacion'],
        stepFormMinder: { stepId: 'loadConfirmationStep' },
        confirmationStep: DeviceConfirmationStep,
      };
      let registeredShopperContinueStep = null;
      let autoSelectHomeShippingAddress = false;
      if(userType === USER_TYPE.OPEN && !isRegisteredShopper){
        initialStepForMinder = 'initialNoClientDevices';
        useCatalogPrice = true;
        autoSelectHomeShippingAddress = true;
        steps = [
          emptyStep,
          VTLNewClientSummary,
          VTLCardPaymentStep,
          riskStep,
          DeviceConfirmationStep,
        ];
        registeredShopperContinueStep = stepIds.vtlNewClientSummaryContinue;
        confirmationInfo = {
          ...confirmationInfo,
          stepFormMinder: { stepId: 'loadNewClientConfirmationStep' },
        }
      }
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps,
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: null,
        flowName: FLOW_TYPES.DEVICES,
        initialStepForMinder,
        confirmationInfo,
        useCatalogPrice,
        isRegisteredShopper,
        registeredShopperContinueStep,
        autoSelectHomeShippingAddress,
        showAddToCartPrices: true,
        sendDiscrepancyAlarmInOneTimeCharges: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.DEVICES,
      };
      break;
    }
    case FLOW_TYPES.R2R: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepInitial,
          commitmentStep,
          shipmentStep,
          scoringStep,
          paymentStep,
          riskStep,
          deviceSummaryStep,
          chooseNumberOTPStep,
          signatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.R2R,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        hideSummaryLegals: true,
        retargeting: true,
        initialStepForMinder: 'initialR2R',
        minProductAgeToChangeAddress: 30,
        sendDiscrepancyAlarmInRecurringCharges: true,
        allowScoring: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.R2R,
        sendOlderPackMobileLineToExtendCQ: true,
        quotaPreselected: CQ_POTS.COMMITMENT_POT["48_MONTHS"],
        // forceOBDWhenErrors: [
        //   WEBSERVICE_ERRORS.ONBOARDING_NEEDED,
        // ],
      };
      break;
    }
    case FLOW_TYPES.R2R_2: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepInitial,
          commitmentStep,
          shipmentStep,
          scoringStep,
          paymentStep,
          riskStep,
          deviceSummaryStep,
          chooseNumberOTPStep,
          signatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.R2R_2,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        hideSummaryLegals: true,
        retargeting: true,
        initialStepForMinder: 'initialR2R',
        minProductAgeToChangeAddress: 30,
        sendDiscrepancyAlarmInRecurringCharges: true,
        allowScoring: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.R2R,
        sendOlderPackMobileLineToExtendCQ: true,
        quotaPreselected: CQ_POTS.COMMITMENT_POT["48_MONTHS"],
        setSoldFlagOnTYP: 'renewalRedeemed',
        callRedeemCampaign: true,
        // forceOBDWhenErrors: [
        //   WEBSERVICE_ERRORS.ONBOARDING_NEEDED,
        // ],
      };
      break;
    }
    case FLOW_TYPES.PACK_R2R: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepInitial,
          commitmentStep,
          shipmentStep,
          scoringStep,
          paymentStep,
          riskStep,
          deviceSummaryStep,
          chooseNumberOTPStep,
          signatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.PACK_R2R,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        hideSummaryLegals: true,
        retargeting: true,
        initialStepForMinder: 'initialR2R',
        minProductAgeToChangeAddress: 30,
        sendDiscrepancyAlarmInRecurringCharges: true,
        allowScoring: true,
        useReceivedAlias: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.R2R,
        quotaPreselected: CQ_POTS.COMMITMENT_POT["48_MONTHS"],
      };
      break;
    }
    case FLOW_TYPES.R2R_AUTO_RENEWAL: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepInitial,
          commitmentStep,
          shipmentStep,
          scoringStep,
          paymentStep,
          riskStep,
          deviceSummaryStep,
          chooseNumberOTPStep,
          signatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.R2R_AUTO_RENEWAL,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        hideSummaryLegals: true,
        retargeting: true,
        initialStepForMinder: 'initialR2RAutoRenewal',
        minProductAgeToChangeAddress: 30,
        sendDiscrepancyAlarmInRecurringCharges: true,
        allowScoring: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.R2R,
        sendOlderPackMobileLineToExtendCQ: true,
        showCancelR2RCheckboxLegal: true,
        sendFailToGenesys: true,
        setSoldFlagOnTYP: 'renewalRedeemed',
        callRedeemCampaign: true,
      };
      break;
    }
    case FLOW_TYPES.PACK: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          installationStep,
          landLineSecondaryActionStep,
          mobileSecondaryActionStep,
          alreadyOwnedProductsChoicesStep,
          ppipStep,
          deviceInstallationStep,
          commitmentStep,
          shipmentStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          chooseNumberOTPStep,
          signatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.PACK,
        initialStepForMinder: 'initialMyProductsNInit',
        secondaryRoundsSteps: [
          mainActionStep,
        ],
        forcedInitialFirstLevelActionIfNecessary: CQ_ACTION_CODES.MIGRATION,
        autoSelectProductId: PRODUCT_TYPES.PACK,
        excludedAutoSelectProductIdRelatedToLocation: [PRODUCT_TYPES.LAND_LINE, PRODUCT_TYPES.BAF, PRODUCT_TYPES.ISR],
        extendedSEMessage: true,
        savePurchaseInProgress: true,
        blockNoActionIfBonusSelected: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.PACK,
        flowTypeTCOLWithoutDowngrades: FLOW_TYPE_TCOL.PACK,
        searchTVHiredProductsToManage: true,
        // blockFlowByProductsType: [PRODUCT_TYPES.NETFLIX],
      };
      break;
    }
    case FLOW_TYPES.DUO: {
      let initialStepForMinder = 'initialDuo';
      let useCatalogPrice = false;
      let automaticConfirmCQ = false;
      let steps = [
        emptyStep,
        obdResidenceErrorStep,
        obdErrorStep,
        personalDataStep,
        forcedInstallationStep,
        mainActionStep,
        landLineSecondaryActionStep,
        ppipStep,
        shipmentStep,
        paymentStep,
        riskStep,
        packSummaryStep,
        confirmationStep,
      ];
      let secondaryRoundsSteps = [
        mainActionStep,
      ]
      let registeredShopperContinueStep = null;
      let forcedLandLineActionIfNecessary = null;
      if(userType === USER_TYPE.OPEN && !isRegisteredShopper){
        initialStepForMinder = 'initialNoClientDuo';
        automaticConfirmCQ = true;
        useCatalogPrice = true;
        forcedLandLineActionIfNecessary = CQ_ACTION_CODES.REGISTER,
        steps = [
          emptyStep,
          DuoNewClientSummary,
          riskStep,
          confirmationStep,
        ];
        secondaryRoundsSteps = [
          portabilityOTPStep,
        ],
        registeredShopperContinueStep = stepIds.duoNewClientSummaryContinue;
      }
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps,
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.DUO,
        initialStepForMinder,
        isRegisteredShopper,
        avoidLegalsExplanatory: true,
        useCatalogPrice,
        registeredShopperContinueStep,
        forcedLandLineActionIfNecessary,
        secondaryRoundsSteps,
        excludedAutoSelectProductIdRelatedToLocation: [PRODUCT_TYPES.LAND_LINE, PRODUCT_TYPES.ISR],
        automaticConfirmCQ,
        sendToSEWithoutBuyInfo: true,
        avoidAddressesOfProductType: PRODUCT_TYPES.PACK,
        deleteRegisteredShopperAndRefresh: true,
        useReceivedAlias: true,
        blockFlowByProductsType: [PRODUCT_TYPES.PACK],
        redirectToAltBuyUrlWhenError: WEBSERVICE_ERRORS.WITHOUT_POSSIBLE_ACTIONS,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.TV: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          paymentStep,
          riskStep,
          summaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.TV,
        initialStepForMinder: 'initial',
        buyProductOfferingAltWhenErrors: [
          WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT,
          WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS,
          WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L,
          WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_BY_ZONE,
          WEBSERVICE_ERRORS.NO_HIRED_PRODUCTS_TO_BUY,
          WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER
        ],
        showProductOfferingChangedModal: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.FTTR: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepInitial,
          paymentStep,
          riskStep,
          deviceSummaryStep,
          chooseNumberOTPStep,
          genericSignatureStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.FTTR,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        hideSummaryLegals: true,
        initialStepForMinder: 'initialFTTR',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
        sendFailToGenesys: true,
      };
      break;
    }
    case FLOW_TYPES.SUBSCRIPTIONS: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.SUBSCRIPTIONS,
        isAddonFlow: true,
        initialStepForMinder: 'initialSubscription',
        extendedSEMessage: true,
        initType: INIT_TYPES.TV,
        animation: WAITING_PAGE_ANIMATIONS.FLYING_PARROT,
        onlyCartOnSummary: true,
      };
      break;
    }
    case FLOW_TYPES.EQUIPMENT: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          afterSaleParentProductSelectorStep,
          deviceInstallationStep,
          shipmentStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.EQUIPMENT,
        initialStepForMinder: 'initialAfterSaleEquipment',
        sendInstallationAddressIfInstallerSelected: true,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
        avoidAfterSaleLegalsExplanatory: true,
        initType: INIT_TYPES.AFTERSALE,
      };
      break;
    }
    case FLOW_TYPES.SPEED_CHANGE: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          deviceInstallationStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.SPEED_CHANGE,
        initialStepForMinder: 'initialAfterSale',
        sendInstallationAddressIfInstallerSelected: true,
        initType: INIT_TYPES.AFTERSALE,
      };
      break;
    }
    case FLOW_TYPES.E_SIM: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          afterSaleParentProductSelectorStep,
          shipmentStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.E_SIM,
        initialStepForMinder: 'initialAfterSaleWithLoa',
        retryAllMobileLines: true,
        forcedOneTimePriceIfNull: 0,
        simTypeToAutoSelect: CHARACTERISTIC_VALUES.SIM_TYPES.E_SIM,
        callRedeemCampaign: true,
        initType: INIT_TYPES.AFTERSALE,
      };
      break;
    }
    case FLOW_TYPES.PREPAID: {
      let initialStepForMinder = 'initialManualNoProducts';
      let steps = [
        emptyStep,
        manualSummaryStep,
        confirmationStep,
      ];
      let registeredShopperContinueStep = null;
      if(userType === USER_TYPE.OPEN && !isRegisteredShopper){
        initialStepForMinder = 'initialNoClientManual';
        steps = [
          emptyStep,
          manualNewClientSummaryStep,
          confirmationStep,
        ];
        registeredShopperContinueStep = stepIds.manualNewClientSummaryContinue;
      }
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps,
        flowType: PURCHASE_TYPE.MANUAL,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'prepago',
        flowName: FLOW_TYPES.PREPAID,
        initialStepForMinder,
        isRegisteredShopper,
        registeredShopperContinueStep,
        manualSEMessage: true,
        changePriceOnPortability: true,
      };
      break;
    }
    case FLOW_TYPES.MULTI_SIM: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStepWithoutInitCQ,
          selectParentProductStep,
          numberOfSimsStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.MULTI_SIM,
        initialStepForMinder: 'initialProductsToHire',
        // simTypeToAutoSelect: CHARACTERISTIC_VALUES.SIM_TYPES.E_SIM,
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
        autoSelectPoshtByCharacSelected: {
          id: '45',
          selections: {
            [CHARACTERISTIC_VALUES.SIM_TYPES.E_SIM]: [CQ_POTS.SHIPPING_POT.WEB_APP],
            [CHARACTERISTIC_VALUES.SIM_TYPES.SIM]: [CQ_POTS.SHIPPING_POT.STORE_SHIPPING_ID],
          }
        } 
      };
      break;
    }
    case FLOW_TYPES.CAR: {
      let initialStepForMinder = 'initialManualNoProducts';
      let steps = [
        emptyStep,
        manualSummaryStep,
        confirmationStep,
      ];
      let registeredShopperContinueStep = null;
      if(userType === USER_TYPE.OPEN && !isRegisteredShopper){
        initialStepForMinder = 'initialNoClientManual';
        steps = [
          emptyStep,
          manualNewClientSummaryStep,
          confirmationStep,
        ];
        registeredShopperContinueStep = stepIds.manualNewClientSummaryContinue;
      }
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps,
        flowType: PURCHASE_TYPE.MANUAL,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.CAR,
        initialStepForMinder,
        isRegisteredShopper,
        registeredShopperContinueStep,
        manualSEMessage: true,
      };      
      break;
    }
    case FLOW_TYPES.MANUAL: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          manualSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.MANUAL,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.MANUAL,
        initialStepForMinder: 'initialManual',
        manualSEMessage: true,
      };
      break;
    }
    case FLOW_TYPES.EMPLOYEES: {
      let initialStepForMinder = 'initialEmployees';
      let steps = [
        emptyStep,
        manualSummaryStep,
        confirmationStep,
      ];
      let registeredShopperContinueStep = null;
      if(userType === USER_TYPE.OPEN && !isRegisteredShopper){
        initialStepForMinder = 'initialNoClientEmployees';
        steps = [
          emptyStep,
          manualNewClientSummaryStep,
          confirmationStep,
        ];
        registeredShopperContinueStep = stepIds.manualNewClientSummaryContinue;
      }
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps,
        flowType: PURCHASE_TYPE.MANUAL,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.EMPLOYEES,
        initialStepForMinder,
        isRegisteredShopper,
        registeredShopperContinueStep,
        manualSEMessage: true,
        retryAllMobileLines: true,
      };
      
      break;
    }
    case FLOW_TYPES.PROTECTION: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          selectParentProductStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.PROTECTION,
        initialStepForMinder: 'initial',
        flowTypeTCOL: FLOW_TYPE_TCOL.OTHER,
      };
      break;
    }
    case FLOW_TYPES.R2R_RENEWAL: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          personalDataStepWithoutInitCQ,
          manualRenewalSummaryStep,
          debtErrorStep,
          riskErrorStep,
          creditLimitErrorStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.MANUAL,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.R2R_RENEWAL,
        initialStepForMinder: 'initialR2RRenewal',
        manualSEMessage: true,
        blockUsersByDocType: [DOC_TYPE_CODE.CIF],
        notShowAccountBlock: true,
        allowPersonalDataChange: true,
        hideSummaryLegals: true,
        sendAliasAtSearch: true,
        setSoldFlagOnTYP: 'renewalRedeemed',
        callRedeemCampaign: true,
        sendFailToGenesys: true,
      };
      break;
    }
    case FLOW_TYPES.CHANGE_OTT_MODALITY: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          deviceInstallationStep,
          shipmentStep,
          paymentStep,
          riskStep,
          oneClickSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.CHANGE_OTT_MODALITY,
        initialStepForMinder: 'initialAfterSaleChangeOTTModality',
        isSimpleActivationFlow: true,
        extendedSEMessage: true,
        initType: INIT_TYPES.NETFLIX,
      };
      break;
    }
    case FLOW_TYPES.BILLIN: {
      flow = {
        resetPath,
        nonOneClickFlowInitialStep: null,
        steps: [
          emptyStep,
          obdResidenceErrorStep,
          obdErrorStep,
          personalDataStep,
          paymentStep,
          riskStep,
          packSummaryStep,
          confirmationStep,
        ],
        flowType: PURCHASE_TYPE.AUTOMATIC,
        defaultAnimation: WAITING_PAGE_ANIMATIONS.BOUNCING_LOGO,
        defaultPaymentMethod: 'domiciliacion',
        flowName: FLOW_TYPES.BILLIN,
        initialStepForMinder: 'initial',
        blockUsersByDocType: [DOC_TYPE_CODE.PASSPORT],
      };
      break;
    }
    default: return null;
  }

  if (userType === USER_TYPE.OPEN) {
    flow.nonOneClickFlowInitialStep = null;
  }

  return flow;
};
